module.exports = __webpack_public_path__ + "img/slider_handle.0b5ee29c.svg";